import { useState } from "react";
import { isSedeMode } from "../utils/partnerAccess/partnerStorage";

/**
 * Whether this tab is working a sede (partner access).
 *
 * Read once per mount: a sede is entered and left only through a full page
 * reload, so the value cannot change while a component is mounted.
 */
const useSedeMode = () => {
  const [sedeMode] = useState(isSedeMode);
  return sedeMode;
};

export default useSedeMode;
